import styled from 'styled-components';

export const Container = styled.div`
  width: -webkit-fill-available;
  background: ${({ theme }) => theme.colors.background};
  padding: 1rem;
  border-radius: 1rem;
  box-shadow: 1px 2px 6px rgb(0 0 0 / 20%);
`;

export const Content = styled.div`
  width: 100%;
  position: relative;

  .icon-copy {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    color: ${({ theme }) => theme.colors.tertiary_500};
    position: absolute;
    top: 0;
    right: 0;

    .button-copy {
      padding: 0;
      min-width: 0;

      svg {
        color: ${({ theme }) => theme.colors.tertiary_500};
      }
    }
  }

  .cnt-card {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .cardItem {
      display: flex;
      flex-direction: column;
      text-align: left;
      font: normal normal 300 16px/23px Futura PT;
      letter-spacing: -0.4px;
      color: ${({ theme }) => theme.colors.text};

      span {
        text-align: left;
        font: normal normal 300 22px/23px Futura PT;
        letter-spacing: -0.55px;
        color: ${({ theme }) => theme.colors.primary};
      }

      .pixKey {
        color: ${({ theme }) => theme.colors.primary};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .pixType {
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.secondary};
      }
    }

    .cardAccount-data {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
`;
